/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { PublishTypes } from '../constants/PublishTypes';
import { TimeIcon } from 'foundations-assets/icons/components/TimeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Bold = ({
  children
}) => {
  return /*#__PURE__*/_jsx("b", {
    children: children
  });
};
const PublishScheduledAlertMessage = () => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: 'components.publishSuccessAlert.scheduledMessage_jsx',
    options: {
      iconProps: {
        size: '200',
        alignWithText: true
      }
    },
    elements: {
      Bold,
      TimeIcon
    }
  });
};
const CancelScheduledUnpublishMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "components.publishSuccessAlert.cancelScheduledUnpublishMessage"
});
const PublishSuccessAlertMessage = ({
  publishedContentUrl
}) => {
  const [urlCopied, setUrlCopied] = useState(false);
  const resetUrlCopiedStatus = () => setUrlCopied(false);
  const handleCopyUrl = () => {
    // eslint-disable-next-line compat/compat
    navigator.clipboard.writeText(publishedContentUrl);
    setUrlCopied(true);
    setTimeout(resetUrlCopiedStatus, 2000);
  };
  const copyUrlToken = urlCopied ? 'components.publishSuccessAlert.copyUrlAction.urlCopied' : 'components.publishSuccessAlert.copyUrlAction.copyUrl';
  return /*#__PURE__*/_jsxs(View, {
    maxInlineSize: "100%",
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "components.publishSuccessAlert.message_jsx",
      options: {
        linkProps: {
          href: publishedContentUrl,
          external: true,
          truncate: true
        }
      },
      elements: {
        Link
      }
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(Button, {
        size: "xs",
        use: "tertiary-light",
        onClick: handleCopyUrl,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: copyUrlToken
        })
      })
    })]
  });
};
const PublishSuccessAlertTitle = ({
  contentType,
  publishType
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `components.publishSuccessAlert.title.${contentType}.${publishType}`
  });
};
export const displayPublishSuccessAlert = ({
  contentType,
  publishType,
  publishedContentUrl
}) => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(PublishSuccessAlertTitle, {
      contentType: contentType,
      publishType: publishType
    }),
    message: publishType === PublishTypes.schedule ? /*#__PURE__*/_jsx(PublishScheduledAlertMessage, {}) : publishType === PublishTypes.cancelScheduledUnpublish ? /*#__PURE__*/_jsx(CancelScheduledUnpublishMessage, {}) : /*#__PURE__*/_jsx(PublishSuccessAlertMessage, {
      publishedContentUrl: publishedContentUrl
    }),
    style: {
      maxWidth: '90%'
    },
    type: 'success',
    timeout: 8000,
    'data-test-id': `publish-success-alert-${publishType}`
  });
};